import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import { selectGameConfig } from "src/store/common"
import { TARGET_ORDER, eligibleUnits } from "src/utils/battlefield"

import Modal from "src/components/modals/Modal"
import UnitItem from "src/components/UnitItem"

/* One board zone, explained: what standing there means, how the damage finds it, and which of
   your units may take the slot. Opened by pressing any cell of the battle board — the zone twin
   of the unit card's stat help. */

const ICONS = { front: "⚔", flanks: "↷", back: "🎯", special: "✦" }

const ZoneHelpModal = ({ zone }) => {
  const { t } = useTranslation()
  const gameConfig = useSelector(selectGameConfig)
  const rules = gameConfig?.rules_config || {}

  return (
    <Modal width="min(680px, 92%)" isolated={false} scope="map" top="8vh" maxHeight="84vh">
      <div className="stat-detail" style={{ padding: 28 }}>
        <h2>
          {ICONS[zone] || "◆"} {t(`game.battle.zones.${zone}`)}
        </h2>
        <p className="stat-detail-note" style={{ fontSize: "0.9375rem", lineHeight: 1.6 }}>
          {t(`game.zoneHelp.${zone}`)}
        </p>
        {/* Who this zone hits, first to last — the engine's `TARGET_ORDER` (owner, 2026-09-13), so a
            player placing a unit knows what it will strike before the battle says so. */}
        <p className="section-label" style={{ marginTop: 18 }}>
          {t("game.zoneHelp.targets")}
        </p>
        <ol className="zone-help-targets" style={{ display: "flex", flexWrap: "wrap", gap: 8, listStyle: "none", padding: 0, margin: "6px 0" }}>
          {(TARGET_ORDER[zone] || []).map((target, index) => (
            <li key={target} className={`unit-modal-zone zone-${target}`}>
              {index + 1}. {ICONS[target] || "◆"} {t(`game.battle.zones.${target}`)}
            </li>
          ))}
        </ol>
        <p className="stat-detail-note" style={{ fontSize: "0.875rem", lineHeight: 1.6 }}>
          {t("game.zoneHelp.targetsNote")}
        </p>
        <p className="stat-detail-note" style={{ fontSize: "0.875rem", lineHeight: 1.6 }}>
          {t("game.zoneHelp.wall")}
        </p>
        <p className="stat-detail-note" style={{ fontSize: "0.9375rem", lineHeight: 1.6 }}>
          {t("game.zoneHelp.slots", {
            count: rules.BATTLEFIELD_ZONE_SLOTS?.[zone] ?? 0,
            perRound: rules.BATTLEFIELD_SLOT_SIZE_PER_ROUND,
            min: rules.BATTLEFIELD_SLOT_SIZE_MIN,
          })}
        </p>
        {/* Both sides of the board: knowing what the enemy may seat here is half the point. */}
        {["human", "zombie"].map((teamKey) => {
          const units = eligibleUnits(gameConfig, teamKey, zone)
          if (units.length === 0) return null
          return (
            <div key={teamKey}>
              <p className="section-label" style={{ marginTop: 18 }}>
                {t("game.zoneHelp.eligible")} · {t(`game.battle.${teamKey}`)}
              </p>
              {/* The chips here are the point of the panel, not a garrison count: twice the size of the ones
                  in a city card, so a portrait reads as the unit it is (owner's ask, 2026-09-06). */}
              <div style={{ display: "flex", flexWrap: "wrap", gap: 10, "--chip-h": "150px", "--chip-w": "135px" }}>
                {units.map((unit) => (
                  <UnitItem key={unit} type={unit} count={null} showLabel />
                ))}
              </div>
            </div>
          )
        })}
      </div>
    </Modal>
  )
}

export default ZoneHelpModal
